























































































































import { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwIcon } from '../sw-icon';
import { CSSStyleOptions, VueRenderFunction } from '../common-types';
import { SwExtendedVue } from '../sw-extended-vue';
import { utilService } from '../util-service';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwPopover extends SwExtendedVue {
  @Prop({ type: Number, default: 200 })
  maxWidth: number;

  @Prop({ type: Number, default: 180 })
  maxHeight: number;

  @Prop({ type: Boolean, default: true })
  withCloseIcon: boolean;

  @Prop({ type: [String, Function] })
  title: string | VueRenderFunction;

  @Prop({ type: Function })
  onRequestClose: () => void;

  @Prop({ type: Boolean, default: false })
  noPadding: boolean;

  cssPrefix: string = 'sw-popover';

  get boardStyle(): CSSStyleOptions {
    return {
      maxHeight: `${this.maxHeight}px`,
      maxWidth: `${this.maxWidth}px`,
    };
  }

  get showHeader(): boolean {
    return !!this.title || this.withCloseIcon;
  }

  onClickClose() {
    if (this.onRequestClose) {
      this.onRequestClose();
    }
  }

  render(h: CreateElement): VNode {// tslint:disable-line
    let headerNode: JSX.Element | null = null;

    if (this.showHeader) {
      const useCustomizedTitle = typeof this.title === 'function';
      headerNode = (
        <div
          class={[
            `${this.cssPrefix}__board__title`,
            {
              [`${this.cssPrefix}__board__title--customized`]: useCustomizedTitle,
              'sw-flexbox': !useCustomizedTitle,
              'sw-flexbox--center-items': !useCustomizedTitle,
            },
          ]}
        >
        {
          useCustomizedTitle ? (
            (this.title as VueRenderFunction)(h)
          ) : [
            <span class={[`${this.cssPrefix}__board__title__text`, 'sw-flexbox__flex']}>{ this.title }</span>,
            this.withCloseIcon ? (
              <div class={[`${this.cssPrefix}__board__title__close`, 'sw-flexbox__flex-none',
                'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify']}
                onClick={this.onClickClose}
              >
                <sw-icon name="close-thin" size={13} />
              </div>
            ) : undefined,
          ]
        }
        </div>
      );
    }
    const rootNode = (
      <div class={[`${this.cssPrefix}`, 'sw-typo-default']}>
        <div class={[`${this.cssPrefix}__board`]} style={this.boardStyle}>
          {headerNode}
          <div class={[`${this.cssPrefix}__board__content`, { [`${this.cssPrefix}__board__content--no-padding`]: this.noPadding }]}>
            <div class={[`${this.cssPrefix}__board__content__inner`]}>{utilService.getVueScopedSlot(this.$scopedSlots)}</div>
          </div>
        </div>
        <div class={[`${this.cssPrefix}__arrow`, { [`${this.cssPrefix}__arrow--no-header`]: !this.showHeader }]} x-arrow></div>
      </div>
    );

    return rootNode as VNode;
  }
}
